"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TradeTrustToken__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [{
    internalType: "string",
    name: "name",
    type: "string"
  }, {
    internalType: "string",
    name: "symbol",
    type: "string"
  }, {
    internalType: "address",
    name: "titleEscrowFactory_",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [],
  name: "InvalidAdminAddress",
  type: "error"
}, {
  inputs: [],
  name: "InvalidTokenId",
  type: "error"
}, {
  inputs: [],
  name: "TokenExists",
  type: "error"
}, {
  inputs: [],
  name: "TokenNotSurrendered",
  type: "error"
}, {
  inputs: [],
  name: "TransferFailure",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Paused",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "previousAdminRole",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "newAdminRole",
    type: "bytes32"
  }],
  name: "RoleAdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleRevoked",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Unpaused",
  type: "event"
}, {
  inputs: [],
  name: "ACCEPTER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "DEFAULT_ADMIN_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "MINTER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "RESTORER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "burn",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "genesis",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }],
  name: "getRoleAdmin",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "grantRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "hasRole",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "mint",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "ownerOf",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "pause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "paused",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "renounceRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "restore",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "revokeRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "string",
    name: "baseURI",
    type: "string"
  }],
  name: "setBaseURI",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "adminRole",
    type: "bytes32"
  }],
  name: "setRoleAdmin",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "symbol",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "titleEscrowFactory",
  outputs: [{
    internalType: "contract ITitleEscrowFactory",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "tokenURI",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "unpause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";

const isSuperArgs = xs => xs.length > 1;

class TradeTrustToken__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(name, symbol, titleEscrowFactory_, overrides) {
    return super.deploy(name, symbol, titleEscrowFactory_, overrides || {});
  }

  getDeployTransaction(name, symbol, titleEscrowFactory_, overrides) {
    return super.getDeployTransaction(name, symbol, titleEscrowFactory_, overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.TradeTrustToken__factory = TradeTrustToken__factory;

_defineProperty(TradeTrustToken__factory, "bytecode", _bytecode);

_defineProperty(TradeTrustToken__factory, "abi", _abi);